<div class="settlement-detail-accept-comment" data-cy="settlement-detail-accept-comment">
    <div class="settlement-detail-accept-comment-description">
        <div class="settlement-detail-body-output-field-label"
             data-cy="settlement-detail-body-output-field-label-accept-comment">{{LABEL_COMMENT}}
        </div>
        <div class="settlement-detail-body-output-field-value settlement-detail-box-border"
             data-cy="settlement-detail-body-output-field-value-accept-comment">{{$safeNavigationMigration(acceptanceComment?.decisionReason) | undefinedValue}}</div>
    </div>
    <div class="settlement-detail-by">
        <div class="settlement-detail-body-output-field-label"
             data-cy="settlement-detail-body-output-field-label-accepted-by-email">{{LABEL_ACCEPTED}}
        </div>
        <div class="settlement-detail-body-output-field-value settlement-detail-body-output-field-value-email"
             data-cy="settlement-detail-body-output-field-value-accepted-by-email">{{$safeNavigationMigration(acceptanceComment?.decidedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    </div>
</div>
